import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Message, SpinnerService } from 'shared-components';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { EtiquetadoService } from "../../../services/etiquetado.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from "@ngx-translate/core";
import { DecimalPipe } from "@angular/common";

@Component({
    selector: 'app-confecciones-pallet-new-component',
    templateUrl: './new-edit.component.html'
})
export class ConfeccionesPalletNewComponent implements OnInit, OnDestroy {

    private readonly destroy$ = new Subject<void>();

    private _confeccionCompleta;

    public newFormSimple: UntypedFormGroup;
    public newFormCompleta: UntypedFormGroup;

    public showError: boolean;
    public showWarning: boolean;
    public mensajes = new Array<Message>();

    public disabledEtiquetadores: Subject<boolean> = new Subject();
    public disabledForm: Subject<boolean> = new Subject();

    public etiquetadores;
    public denominaciones;
    public denominacionesPorciones = [];
    public cajasPallet = [];

    public cajas = [];
    public insertCajas = [];

    public etiquetadorId;

    public simpleModal = false;
    public resumenModal = false;

    public resetDistribucion = false;

    public showCreate = true;

    public newCajas = false;

    public sumaKilos;
    public porcionesEnvase;

    public idTabla = 1;

    public lsCajas = [];

    public numCajas = 1;

    public tipoConfeccionList = [
        {
            id: 1,
            des: this._translate.instant('mantenimientoConfecciones.confeccion.tipos.caja')
        },
        {
            id: 2,
            des: this._translate.instant('mantenimientoConfecciones.confeccion.tipos.pallet')
        }
    ];

    @Input() tipoConfeccion: number;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _dataProvider: DataProvider,
        private readonly _translate: TranslateService,
        private readonly  _decimalPipe: DecimalPipe
    ) { }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    ngOnInit() {
        this.newFormCompleta = this._fb.group({
            des: ['', Validators.required],
            alias: [''],
            etiquetador: ['', Validators.required],
            tipoConfeccion: [{ value: this.tipoConfeccionList.find(x => x.id === this.tipoConfeccion), disabled: true }, Validators.required],
            pesoPallet: ['']
        });

        this.getEtiquetadores();
        this.newFormCompleta.get('etiquetador').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((etiquetador) => {
            if (etiquetador) {
                this.etiquetadorId = etiquetador.id;
                let _filters = {
                    etiquetadorId: etiquetador.id,
                    tienePDConPermisoConfeccionPallet: true
                };
                this._spinnerService.showSpinner();
                this._etiquetadoService.getDenominaciones(_filters).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.denominaciones = resp.lista;
                        this.denominaciones.push({ id: null, des: 'Mix' })
                    } else {
                        this.denominaciones = [];
                    }
                });
            } else {
                this.etiquetadorId = null;
                this.newCajas = false;
                this.denominaciones = [];
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public getEtiquetadores() {
        let _filters = {
            tienePDConPermisoConfeccionPallet: true
        };
        this._spinnerService.showSpinner();
        this._etiquetadoService.getEtiquetadores(_filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.etiquetadores = resp.lista;
            if (this.etiquetadores.length === 1) {
                this.newFormCompleta.get('etiquetador').patchValue(this.etiquetadores[0]);
                this.newFormCompleta.get('etiquetador').disable();
                this.disabledEtiquetadores.next(true);
            } else {
                this.newFormCompleta.get('etiquetador').enable();
                this.newFormCompleta.get('etiquetador').patchValue('');
                this.disabledEtiquetadores.next(false);
            }
        });
    }

    public get tiposConfeccion() {
        return this.tipoConfeccionList;
    }

    public close() {
        this.refresh.emit(false);
    }

    public addCompleta() {
        this.checkFormCompleta();
        if (this.newFormCompleta.valid) {
            this._confeccionCompleta = {
                des: this.newFormCompleta.get('des').value ? this.newFormCompleta.get('des').value : '',
                alias: this.newFormCompleta.get('alias').value ? this.newFormCompleta.get('alias').value : '',
                tipoConfeccionId: this.newFormCompleta.get('tipoConfeccion').value ? this.newFormCompleta.get('tipoConfeccion').value.id : '',
                lsConfeccionesCaja: this.insertCajas
            };
            this._spinnerService.showSpinner();
            this._etiquetadoService.createConfeccionCompletaPallet(this._confeccionCompleta).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then(
                (resp) => {
                    this.refresh.emit(true);
                    this.mensaje.emit('global.success.itemUpdated');
                },
                (error) => {
                    this.showError = true;
                    let mensaje;
                    if (error.status === 420) {
                        switch (error.error.ApiErrorCode) {
                            case 3002:
                                mensaje = this._translate.instant('ApiErrors.noDuplicarCaja');
                                break;
                            case 6015:
                                mensaje = this._translate.instant('ApiErrors.confeccionNoContieneCajas');
                                break;
                            case 6165: //ConfeccionYaExiste
                                mensaje = this._translate.instant('ApiErrors.confeccionYaExiste');
                                break;
                            default:
                                mensaje = this._translate.instant('ApiErrors.serverError');
                                break;
                        }
                    } else {
                        mensaje = this._translate.instant('ApiErrors.serverError');
                    }
                    this.mensajes.push({ class: 'error', message: mensaje });
                }
            );
        }
    }

    private checkFormCompleta() {
        this.showError = this.newFormCompleta.invalid;
        if (this.showError) {
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
    }

    public refreshAddCajas(confeccion) {
        if (confeccion) {
            this.cajasPallet.push(confeccion);
            this.insertCajas.push({
                confeccionId: confeccion.id,
                numCajas: confeccion.cantidad
            });
            this.idTabla++;
            this.newCajas = false;
            this.setPesoPallet(confeccion, true);
        }
    }

    public refreshRemove(caja) {
        const index = this.cajasPallet.indexOf(caja);
        this.setPesoPallet(caja, false);
        if (index > -1) {
            this.cajasPallet.splice(index, 1);
            this.insertCajas.splice(index, 1);
        }
    }

    public setPesoPallet(confeccion, add) {
        const peso = add ? Number(this.newFormCompleta.get('pesoPallet').value) + (Number(confeccion.peso) * Number(confeccion.cantidad)) :
            Number(this.newFormCompleta.get('pesoPallet').value) - (Number(confeccion.peso) * Number(confeccion.cantidad));

        if (peso <= 0) {
            this.newFormCompleta.get('pesoPallet').reset();
        } else {
            this.newFormCompleta.get('pesoPallet').reset(peso);
        }
    }
}
